// extracted by mini-css-extract-plugin
var _1 = "CourseSidebar_buttonBack__f0607";
var _2 = "CourseSidebar_content__fbf6e";
var _3 = "CourseSidebar_defaultStructure__97507";
var _4 = "CourseSidebar_headerTitle__3d259";
var _5 = "CourseSidebar_headerTitleWrapper__00458";
var _6 = "CourseSidebar_progress__2f468";
var _7 = "CourseSidebar_progressWrapper__db6b1";
var _8 = "CourseSidebar_resetOffset__328e3";
var _9 = "CourseSidebar_reverseProgress__90d2f";
var _a = "CourseSidebar_root__1aa6c";
var _b = "CourseSidebar_row__e23d8";
var _c = "CourseSidebar_searchWrapper__5b46e";
export { _1 as "buttonBack", _2 as "content", _3 as "defaultStructure", _4 as "headerTitle", _5 as "headerTitleWrapper", _6 as "progress", _7 as "progressWrapper", _8 as "resetOffset", _9 as "reverseProgress", _a as "root", _b as "row", _c as "searchWrapper" }
